import { NgModule } from '@angular/core';
import {LinkyModule} from 'ngx-linky';

import { RelativeDatePipe } from './relative-date.pipe';
import { FormattedDatePipe } from './formatted-date.pipe';
import { FormattedCountPipe } from './count-date.pipe';
import { LinkifyPipe } from './linkify.pipe';
import { SafeValuePipe } from './safe-value.pipe';
import { IconByNamePipe } from './icon-by-name.pipe';
import { CreationDatePipe } from './creation-date.pipe';

@NgModule({
  imports: [
    LinkyModule,
  ],
  declarations: [
    RelativeDatePipe,
    FormattedDatePipe,
    FormattedCountPipe,
    IconByNamePipe,
    LinkifyPipe,
    SafeValuePipe,
    CreationDatePipe,
  ],
  exports: [
    RelativeDatePipe,
    FormattedDatePipe,
    FormattedCountPipe,
    IconByNamePipe,
    LinkifyPipe,
    LinkyModule,
    SafeValuePipe,
    CreationDatePipe
  ],
})
export class PipesModule {
}
